import { useState } from 'react'

import buyoutIcon from '../../../../assets/buyoutIcon.png'

export default function BuyoutOption({ withPEO, selectingRefundOption, handleSelectRefundOption }) {
  const [checked, setChecked] = useState(false)

  return (
    <div className='h-full flex flex-col items-center shadow-md bg-gray-50 flex-1'>
      <div className='flex flex-col items-center bg-gray-100 w-full p-4'>
        <img src={buyoutIcon} alt='Buyout Icon' />
        <p className='font-bold text-xl'>BUYOUT PROGRAM</p>
        <p className='font-bold'>80-85% of principle - in as little as 30 days</p>
      </div>
      <div className='w-full flex flex-col gap-6 p-4 h-full bg-ertc-secondary'>
        <div className='bg-white p-4'>
          <p className='font-bold'>Buyout Program</p>
          <p>Receive 80-85% of your total ERC refund in as little as 30 days.</p>
          <ul className='list-disc ml-5 mt-2'>
            <li>Fast access to your funds</li>
            <li>No out-of-pocket funds</li>
            <li>We're paid when your claim is funded</li>
          </ul>
        </div>
        {!withPEO && (
          <label className='flex items-start space-x-2 cursor-pointer text-white'>
            <input
              type='checkbox'
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              className='h-5 w-5 rounded border-gray-300'
            />
            <span>I acknowledge that if I'm not approved for the buyout program, I will be processed in the accelerate program.</span>
          </label>
        )}
        <button
          disabled={selectingRefundOption || (!checked && !withPEO)}
          className='w-full mt-auto rounded-lg p-2 transition duration-200 text-white bg-ertc-primary disabled:bg-gray-400 disabled:cursor-not-allowed'
          onClick={() => handleSelectRefundOption(false)}
        >
          Choose Buyout Program
        </button>
      </div>
    </div>
  )
}